document.addEventListener('DOMContentLoaded', function() {
  function initRevoltSlider() {
    const sliders = document.querySelectorAll('.revolt-slider-section');
    
    sliders.forEach(function(slider) {
      const container = slider.querySelector('.revolt-slider-slides');
      if (!container) return;

      const slides = slider.querySelectorAll('.revolt-slide');
      const dots = slider.querySelectorAll('.revolt-slider-dot');
      const prevBtn = slider.querySelector('.prev-arrow');
      const nextBtn = slider.querySelector('.next-arrow');
      
      let currentIndex = 0;
      let autoplayTimer = null;
      
      const isAutoplay = container.getAttribute('data-autoplay') === 'true';
      const autoplaySpeed = parseInt(container.getAttribute('data-autoplay-speed'), 10) || 6000;
      
      // Update custom property for dot loader duration
      dots.forEach(dot => {
        dot.style.setProperty('--autoplay-duration', autoplaySpeed + 'ms');
      });

      function goToSlide(index) {
        if (index < 0) {
          index = slides.length - 1;
        } else if (index >= slides.length) {
          index = 0;
        }
        
        slides.forEach(slide => slide.classList.remove('active'));
        dots.forEach(dot => dot.classList.remove('active'));
        
        slides[index].classList.add('active');
        if (dots[index]) {
          dots[index].classList.add('active');
        }
        
        currentIndex = index;
        
        // Reset autoplay timer when manual nav happens
        if (isAutoplay) {
          startAutoplay();
        }
      }
      
      function nextSlide() {
        goToSlide(currentIndex + 1);
      }
      
      function prevSlide() {
        goToSlide(currentIndex - 1);
      }
      
      function startAutoplay() {
        stopAutoplay();
        autoplayTimer = setInterval(nextSlide, autoplaySpeed);
      }
      
      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }
      
      // Controls Events
      if (prevBtn) {
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          prevSlide();
        });
      }
      
      if (nextBtn) {
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          nextSlide();
        });
      }
      
      dots.forEach(function(dot) {
        dot.addEventListener('click', function(e) {
          e.preventDefault();
          const targetIndex = parseInt(this.getAttribute('data-index'), 10);
          goToSlide(targetIndex);
        });
      });
      
      // Touch Swipes for Mobile
      let touchStartX = 0;
      let touchEndX = 0;
      
      container.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      
      container.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }, { passive: true });
      
      function handleSwipe() {
        const threshold = 50; // swipe offset threshold
        if (touchEndX < touchStartX - threshold) {
          // Swiped left
          nextSlide();
        } else if (touchEndX > touchStartX + threshold) {
          // Swiped right
          prevSlide();
        }
      }
      
      // Start Slider
      if (isAutoplay) {
        startAutoplay();
      }
    });
  }

  // Initialize
  initRevoltSlider();

  // Support Shopify Theme Customizer section reload/load events
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('section') || event.target.querySelector('.revolt-slider-section')) {
      initRevoltSlider();
    }
  });
});
